import { render, staticRenderFns } from "./CompositeBoxForRatio.vue?vue&type=template&id=3702ad9a&scoped=true"
import script from "./CompositeBoxForRatio.vue?vue&type=script&lang=js"
export * from "./CompositeBoxForRatio.vue?vue&type=script&lang=js"
import style0 from "./CompositeBoxForRatio.vue?vue&type=style&index=0&id=3702ad9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702ad9a",
  null
  
)

export default component.exports